import { render, staticRenderFns } from "./StudioCompetitionsTab.vue?vue&type=template&id=67339240&scoped=true"
import script from "./StudioCompetitionsTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioCompetitionsTab.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioCompetitionsTab.vue?vue&type=style&index=0&id=67339240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67339240",
  null
  
)

export default component.exports